import React, { useEffect, useState } from "react";
import {
  GetManageStore,
  PostAdminStore,
  StoreTab,
} from "../../Services/StoreHub";
import LockResetIcon from "@mui/icons-material/LockReset";
import AddStore from "./AddStore";
import ResetPassword from "./ResetPassword";
import { BiChip } from "react-icons/bi";
import ChipPopover from "./ChipPopover.js";
import StoreHubSkeleton from "./StoreHubSkeleton/index.js";
import { Pagination, Switch } from "@mui/material";
import { MdVerified } from "react-icons/md";
import { FaHourglassHalf } from "react-icons/fa";
import { toast } from "react-toastify";
import Visibility from "@mui/icons-material/Visibility";
import PreviewIcon from "@mui/icons-material/Preview";
import TabModal from "./TabModal/index.js";

const StoreHub = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showAddStore, setShowAddStore] = useState(false);
  const [resetPasswordStore, setResetPasswordStore] = useState(null);
  const [popoverAnchor, setPopoverAnchor] = useState(null);
  const [popoverStore, setPopoverStore] = useState(null);

  const [selectedStore, setSelectedStore] = useState(null);
  const [showTabModal, setShowTabModal] = useState(false);

  const fetchManageStore = async (page) => {
    try {
      setLoading(true);
      const res = await GetManageStore({ page, search: search });
      // console.log(res);
      setData(res?.data || []);
      setLoading(false);
    } catch (err) {
      throw new Error(err);
    }
  };
  useEffect(() => {
    fetchManageStore(page);
  }, [page, search]);

  const AdminVerifyStore = async (id) => {
    try {
      const res = await PostAdminStore({ store_id: id });
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        await fetchManageStore();
      } else {
        toast.warn(res?.data?.message);
      }
    } catch (err) {
      throw new Error(err);
    }
  };

  const handleChange = (e, value) => {
    setPage(value);
  };
  if (showAddStore) {
    return (
      <AddStore
        showAddStore={showAddStore}
        setShowAddStore={setShowAddStore}
        fetchManageStore={fetchManageStore}
      />
    );
  }
  if (resetPasswordStore) {
    return (
      <ResetPassword
        store={resetPasswordStore}
        onClose={() => setResetPasswordStore(null)}
      />
    );
  }
  const handleChipClick = (event, store) => {
    setPopoverAnchor(event.currentTarget);
    setPopoverStore(store);
  };

  const handlePopoverClose = () => {
    setPopoverAnchor(null);
    setPopoverStore(null);
  };


  console.log(data, "pagination data======>>>>>>>>")

  return (
    <div>
      <div className="w-full mx-auto px-4 py-6">
        <div className="">
          <p className="md:text-2xl text-lg font-bold text-black pb-2">
            Store Hub
          </p>
        </div>
        <div className="py-2 flex md:flex-row flex-col items-center justify-between">
          <div className="md:w-1/2 w-full">
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              placeholder="Start typing to search the Store..."
              className="w-full  border px-4 py-2 rounded-md"
            />
          </div>
          <div className="md:w-1/2 w-full flex items-center justify-end">
            <button
              onClick={() => setShowAddStore(true)}
              className="border border-blue-500 text-blue-500 hover:bg-blue-50 px-4 py-2 rounded"
            >
              Add Store
            </button>
          </div>
        </div>

        {loading ? (
          <StoreHubSkeleton />
        ) : data?.data?.length > 0 ? (
          <>
            <div className="overflow-x-auto bg-white shadow-md rounded-lg border border-gray-200 mt-6">
              <table className="w-full text-sm text-left text-gray-700 min-w-[1000px]">
                <thead className="text-xs text-gray-500 uppercase bg-gray-50 border-b text-center">
                  <tr>
                    <th className="px-4 py-3">ID</th>
                    <th className="px-4 py-3">Store Name</th>

                    <th className="px-4 py-3">Email</th>
                    <th className="px-4 py-3">Token</th>

                    <th className="px-4 py-3">Tab</th>
                    <th className="px-4 py-3">Status</th>
                    <th className="px-4 py-3">Reset Password</th>
                    <th className="px-4 py-3">Created At</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {data?.data?.map((store) => (
                    <tr
                      key={store.id}
                      className="border-b hover:bg-gray-50 transition-all"
                    >
                      <td className="px-4 py-3">{store.id}</td>
                      <td className="px-4 py-3 font-medium">
                        {store.store_name || "—"}
                      </td>

                      <td className="px-4 py-3">{store.email || "—"}</td>
                      <td className="px-4 py-3 ">
                        <button
                          onClick={(e) => handleChipClick(e, store)}
                          className="text-sm px-3 py-1 rounded-md bg-purple-100 text-purple-600 hover:bg-purple-200 hover:text-purple-800 transition"
                        >
                          <Visibility />

                        </button>
                      </td>

                      <td className="px-4 py-3">
                        <button
                          onClick={() => {
                            setSelectedStore(store);
                            setShowTabModal(true);
                          }}
                          className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-red-50 text-red-800 hover:bg-red-100 transition text-sm font-medium"
                        >
                          <PreviewIcon className="text-xs" />

                        </button>
                      </td>
                      <td className="px-4 py-3">
                        {/* {store?.is_active ? (
                          <button
                            onClick={() => AdminVerifyStore(store?.id)}
                            className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-semibold bg-green-100 text-green-600 cursor-default"
                          >
                            <MdVerified size={14} />
                            Active
                          </button>
                        ) : (
                          <button
                            onClick={() => AdminVerifyStore(store?.id)}
                            className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-semibold bg-yellow-100 text-yellow-600 hover:bg-yellow-200 transition"
                          >
                            <FaHourglassHalf size={14} />
                            Verify
                          </button>
                        )} */}


                        <Switch checked={store?.is_active} size="medium" onChange={() => AdminVerifyStore(store?.id)} />
                      </td>

                      <td className="px-4 py-3  ">
                        <button
                          onClick={() => setResetPasswordStore(store)}
                          className="inline-flex items-center justify-center px-2 py-1 rounded-md bg-sky-50 hover:bg-sky-100 transition text-sky-600 hover:text-sky-800"
                          title="Reset Password"
                        >
                          <LockResetIcon className="text-2xl" />
                        </button>
                      </td>

                      <td className="px-4 py-3 text-gray-600">
                        {new Date(store.created_at).toLocaleDateString()}{" "}
                        {new Date(store.created_at).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="flex items-center justify-center pt-2">
              <Pagination
                count={data?.total_page}
                page={page}
                onChange={handleChange}
                color="primary"
              />
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-12">
            <img
              loading="lazy"
              src="https://plus.unsplash.com/premium_photo-1739178656557-16b949fea186?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8bm8lMjB1c2VyJTIwcHJvZmlsZXxlbnwwfHwwfHx8MA%3D%3D"
              alt="No data"
              className="w-48 h-48 object-contain mb-4"
            />
            <p className="text-gray-500 text-center text-sm">
              No Store Hub found.
            </p>
          </div>
        )}
      </div>

      <ChipPopover
        anchorEl={popoverAnchor}
        onClose={handlePopoverClose}
        store={popoverStore}
      />
      <TabModal
        open={showTabModal}
        store={selectedStore}
        onClose={() => {
          setShowTabModal(false);
          setSelectedStore(null);
        }}
      />
    </div>
  );
};

export default StoreHub;
